import { render, staticRenderFns } from "./GlobalFooter.vue?vue&type=template&id=f7974e50"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports